export default __webpack_public_path__ + "static/media/weight.dfe0e687.svg";